import type { UIMessage } from 'ai'

export function toolPartDisplayName(part: UIMessage['parts'][number]): string {
  if (part.type === 'dynamic-tool') {
    return part.toolName
  }
  if (part.type.startsWith('tool-')) {
    return part.type.slice('tool-'.length)
  }
  return part.type
}
